import React from 'react'

const GolfApparel = () => {
    return (
        <div>GolfApparel</div>
    )
}

export default GolfApparel